<template>
  <div>
    <slot />
    <common-spinner />
    <common-dialog />
  </div>
</template>
